export const SegmentationList = 'SegmentationList'

export const SegmentationMessages = 'SegmentationMessages'

export const SegmentationView = 'SegmentationView'

export const SegmentationCustomers = 'SegmentCustomers'

export const List = 'List'

export const ListView = 'ListView'

export const PaymentEvents = 'PaymentEvents'

export const AutomationLog = 'AutomationLog'

export const MessageableMessageList = 'MessageableMessageList'

export const CollectionAccounts = 'CollectionAccounts'

export const AutomationLogs = 'AutomationLogs'

export const Automations = 'Automations'

export const CustomMessageList = 'CustomMessageList'

export const CustomMessageSms = 'CustomMessageSms'

export const CustomMessageEmail = 'CustomMessageEmail'
